import type { FC, ReactElement } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { IconContainer } from '@/components/ui/icon-container'
import { useGetFlags } from '@/features/photoset/queries/use-get-flags'
import { useTranslation } from '@/translations/i18n'

interface EmptyFlagsResultProps {
	title: string
	hasRetry: boolean
	icon?: ReactElement
}

export const EmptyFlagsResult: FC<EmptyFlagsResultProps> = ({
	title,
	icon,
	hasRetry
}) => {
	const { t } = useTranslation()
	const { refetch, isRefetching } = useGetFlags(
		{
			params: {
				response_type: 'extended'
			}
		},
		{ enabled: false }
	)

	return (
		<div className='flex flex-col items-center gap-4 py-8'>
			{icon && <IconContainer>{icon}</IconContainer>}
			<h3 className='text-center font-semibold text-lg text-neutral-900'>
				{title}
			</h3>
			{hasRetry && (
				<ButtonLegacy
					disabled={isRefetching}
					onClick={() => refetch()}
					type='button'
				>
					{t('common:retry')}
				</ButtonLegacy>
			)}
		</div>
	)
}
